import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import {SCMProject} from '../../../models/SCMProject';
import {ProjectService} from '../../../services/project.service';

@Injectable()
export class ProjectsResolver implements Resolve<Array<SCMProject>> {

    resolve(): Observable<Array<SCMProject>> {

        return this.projectService.getCustomerProjects();

    }

    constructor(private projectService: ProjectService) { }
}
